module.exports = __webpack_public_path__ + "img/SolR.07a718ec.png";